import styled from "styled-components"
import {RouterLink} from "@irati/ui/src/Link"

export const StyledRouterLink = styled(RouterLink)`
  &:hover {
    box-shadow: none;
  }
` as typeof RouterLink
